<template>
  <Dialog 
    :title="title"
    :customClose="close"
    :submitButtonText="buttonText"
    @submit="saveQuestion"
  >
    <div v-if="showSpinner" class="spinner-wrap">
      <spinner />
    </div>
    <form v-else @submit.prevent="saveQuestion">
      <div class="form-group">
        <label for="question">Question Text*</label>
        <input
          type="text"
          v-validate="'required|max:255'"
          id="question"
          name="question"
          class="form-control"
          :class="{'is-invalid': errors.has('question')}"
          v-model.trim="questionText"
          autofocus
        >
        <small v-show="errors.has('question')" class="invalid-feedback">
          {{ errors.first('question') }}
        </small>
      </div>
      <div class="form-group">
        <label for="question">Answer Text*</label>
        <textarea
          v-validate="'required|max:1024'"
          id="answer"
          name="answer"
          class="form-control"
          :class="{'is-invalid': errors.has('answer')}"
          v-model.trim="answerText"
          autofocus
        >
        </textarea>
        <small v-show="errors.has('answer')" class="invalid-feedback">
          {{ errors.first('answer') }}
        </small>
      </div>
    </form>
  </Dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import Dialog from '@/components/Dialog';
import CREATE_QUESTION from '@/graphql/Campaigns/CreateQuestion.gql';
import EDIT_QUESTION from '@/graphql/Campaigns/EditQuestion.gql';
import { option, optionIf } from '@/helpers/stdlib';

export default {
  components: {
    Dialog,
  },
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    questionId: Number,
    question: String,
    answer: String,
  },
  computed: {
    ...mapGetters(['getAuthUser']),
    buttonText() {
      return this.questionId === undefined ? 'Save' : 'Save';
    },
    title() {
      return this.questionId === undefined ? 'New Question' : 'Edit Question';
    },
  },
  data() {
    return {
      questionText: this.question || '',
      answerText: this.answer || '',
      showSpinner: false,
    };
  },
  methods: {
    close() {
      this.$router.push({
        name: 'CampaignDetails',
        params: { id: this.campaignId },
        query: { updatedAt: Date.now(), tab: 'q_a' },
      });
    },
    async saveQuestion() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }
      this.showSpinner = true;
      await this.$apollo.mutate({
        mutation: this.questionId === undefined ? CREATE_QUESTION : EDIT_QUESTION,
        variables: {
          question: {
            ...optionIf(!this.questionId, 'campaignId', this.campaignId),
            ...option('questionId', this.questionId),
            question: this.questionText,
            answer: this.answerText,
          },
        },
      });
      this.close();
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modals/NewQuestions.vue